import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    LabelList,
    ResponsiveContainer
} from "recharts";

const STATUS_COLORS = {
    Open: "#ef4444",       // Red
    Closed: "#22c55e",     // Green
    Freeze: "#f59e0b",     // Yellow
    Cancelled: "#6b7280"   // Grey
};

const JobRequirementChart = ({ data }) => {

    const total = data.reduce(
        (sum, item) => sum + Number(item.Total || 0),
        0
    );

    const CustomTooltip = ({ active, payload, label }) => {
        if (!active || !payload || !payload.length) return null;

        const row = payload[0]?.payload;

        return (
            <div
                style={{
                    background: "#fff",
                    border: "1px solid #ccc",
                    padding: "10px",
                    borderRadius: "5px"
                }}
            >
                <p><strong>{label}</strong></p>

                <p style={{ color: STATUS_COLORS.Open }}>
                    Open : {row.Open}
                </p>

                <p style={{ color: STATUS_COLORS.Closed }}>
                    Closed : {row.Closed}
                </p>

                <p style={{ color: STATUS_COLORS.Cancelled }}>
                    Cancelled : {row.Cancelled}
                </p>

                <p style={{ color: STATUS_COLORS.Freeze }}>
                    Freeze : {row.Freeze}
                </p>

                <hr />

                <p>
                    <strong>Total : {row.Total}</strong>
                </p>
            </div>
        );
    };

    return (
        <div style={{ width: "100%", height: 350 }}>
            <h3>Job Requirements (Total: {total})</h3>

            <ResponsiveContainer>
                <BarChart
                    data={data}
                    margin={{ top: 20, right: 20, left: 0, bottom: 0 }}
                >
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip
                        content={<CustomTooltip />}
                        cursor={false}
                    />
                    <Legend />

                    <Bar
                        dataKey="Open"
                        stackId="a"
                        fill={STATUS_COLORS.Open}
                    />

                    <Bar
                        dataKey="Closed"
                        stackId="a"
                        fill={STATUS_COLORS.Closed}
                    />

                    <Bar
                        dataKey="Cancelled"
                        stackId="a"
                        fill={STATUS_COLORS.Cancelled}
                    />

                    <Bar
                        dataKey="Freeze"
                        stackId="a"
                        fill={STATUS_COLORS.Freeze}
                    >
                        <LabelList
                            dataKey="Total"
                            position="top"
                        />
                    </Bar>

                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default JobRequirementChart;